var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-flix-layout',{attrs:{"variant":"main-header"}},[_c('b-flix-h1',{staticStyle:{"display":"block","margin-bottom":"20px"},attrs:{"variant":"white"}},[_vm._v(" "+_vm._s(_vm.category)+" ")]),_c('b-flix-h2',{attrs:{"variant":"white"}},[_c('flixIcon',{attrs:{"id":_vm.icon}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }